import React, { useEffect } from "react";
import 'react-multi-carousel/lib/styles.css';
import useScrollReset from "@hooks/ScrollHook";
import { Link, useNavigate } from "react-router-dom";
import { useApi } from "@hooks/ApiHook";
import useModal from "@hooks/ModalHook";

function HomePage() {
    const { openModal } = useModal()
    useScrollReset()
    const { data: links } = useApi(api => api.link.random())

    return <>
        <main className="pt-[5.5rem] lg:pt-24">

            <section className="relative px-6 pb-8">
                <a href="https://garuda-defi.bigbangx.io"><img width={125} src="" alt="" srcSet="/src/img/logo/garudaDefiLogo.png" /></a>
                <div className="flex flex-col gap-5 lg:flex-row mt-4">
                    <div className="w-full lg:w-1/3">
                        <div className="grid grid-cols-2 grid-rows-2 gap-5">
                            {
                                links?.slice(0, 4).map(link => link != null ? <article>
                                    <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-jacarta-700">
                                        <figure className="relative">
                                            <Link to={link.url}
                                                className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20">
                                                <img src={link.image ?? "/src/img/logo/transparant_logo.png"} alt="item 1"
                                                    className="w-full aspect-square object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                                                    height="293" width="293" />
                                            </Link>
                                        </figure>
                                        <div className="pointer-events-none absolute bottom-0 w-full p-5">
                                            <h2 className="font-display text-base leading-none text-white xl:text-lg">{link.name}</h2>
                                            {
                                                link.subtitle && <span className="text-2xs text-white">{link.subtitle}</span>
                                            }
                                        </div>
                                    </div>
                                </article> :
                                    <article>
                                        <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-gray-900">
                                            <figure className="relative">
                                                <div
                                                    className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20">
                                                    <img src="/src/img/logo/transparant_logo.png" alt="item 1"
                                                        className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                                                        height="293" width="293" />
                                                </div>
                                            </figure>
                                        </div>
                                    </article>)
                            }

                        </div>
                    </div>
                    <div className="w-full lg:w-1/3">
                        <div className="grid grid-cols-1 gap-5">
                            <article>
                                <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-jacarta-700">
                                    <figure className="relative">
                                        <Link to={"/air-force-lunc"}
                                            className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20">
                                            <img src="https://ipfs.miata-ipfs.com/ipfs/QmYKNqaAh4TCbX42gGLy6DQsaHNVWzN85fKMcXTJ2yXBBh/1.png" alt="item 20"
                                                className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                                                height="293" width="959" />
                                        </Link>
                                    </figure>
                                    <div className="pointer-events-none absolute bottom-0 w-full p-5">
                                        <h2 className="font-display text-2xl leading-none text-white">Air Force Lunc</h2>
                                    </div>
                                </div>
                            </article>
                            <article>
                                <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-jacarta-700">
                                    <figure className="relative">
                                        <Link to={"/lunc-zombies"}
                                            className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20">
                                            <img src="https://gcdnb.pbrd.co/images/tNbT1UK2tkuG.jpg?o=1" alt="item 20"
                                                className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                                                height="293" width="959" />
                                        </Link>
                                    </figure>
                                    <div className="pointer-events-none absolute bottom-0 w-full p-5">
                                        <h2 className="font-display text-2xl leading-none text-white">Lunc Zombies</h2>
                                    </div>
                                </div>
                            </article>
                        </div>

                    </div>
                    <div className="w-full lg:w-1/3">
                        <div className="grid grid-cols-2 grid-rows-2 gap-5">
                            {
                                links?.slice(4).map(link => link != null ? <article>
                                    <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-jacarta-700">
                                        <figure className="relative">
                                            <Link to={link.url}
                                                className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20">
                                                <img src={link.image ?? "/src/img/logo/transparant_logo.png"} alt="item 1"
                                                    className="w-full aspect-square object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                                                    height="293" width="293" />
                                            </Link>
                                        </figure>
                                        <div className="pointer-events-none absolute bottom-0 w-full p-5">
                                            <h2 className="font-display text-base leading-none text-white xl:text-lg">{link.name}</h2>
                                            {
                                                link.subtitle && <span className="text-2xs text-white">{link.subtitle}</span>
                                            }
                                        </div>
                                    </div>
                                </article> :
                                    <article>
                                        <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-gray-900">
                                            <figure className="relative">
                                                <div
                                                    className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20">
                                                    <img src="/src/img/logo/transparant_logo.png" alt="item 1"
                                                        className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                                                        height="293" width="293" />
                                                </div>
                                            </figure>
                                        </div>
                                    </article>)
                            }
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-24 bg-dark">
                <div className="container">
                    <h2 className="mb-10 text-center font-display text-3xl text-jacarta-700 dark:text-white">
                        Get Started
                    </h2>
                    <div className="cursor-pointer grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                        <div
                            onClick={() => openModal("wallet")}
                            className="cursor-pointer relative rounded-2.5xl border p-10 shadow-[0_5px_0_0_#8358ff] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(131,88,255,.3)] border-jacarta-700 bg-dark2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                className="absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600">
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path
                                    d="M22 6h-7a6 6 0 1 0 0 12h7v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2zm-7 2h8v8h-8a4 4 0 1 1 0-8zm0 3v2h3v-2h-3z" />
                            </svg>
                            <div className="mb-6 inline-flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                    className="h-12 w-12 fill-accent">
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path
                                        d="M22 6h-7a6 6 0 1 0 0 12h7v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2zm-7 2h8v8h-8a4 4 0 1 1 0-8zm0 3v2h3v-2h-3z" />
                                </svg>
                            </div>
                            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">Connect your Wallet</h3>
                            <p className="dark:text-jacarta-300">
                                Once you've set up your wallet of choice, connect it to OpenSeaby clicking the NFT Marketplacein the top
                                right corner.
                            </p>
                        </div>
                        <Link
                            to={"/collections"}
                            className="relative rounded-2.5xl border p-10 shadow-[0_5px_0_0_#10b981] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(16,185,129,.3)] border-jacarta-700 bg-dark2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                className="absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600">
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
                            </svg>
                            <div className="mb-6 inline-flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                    className="h-12 w-12 fill-green">
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
                                </svg>
                            </div>
                            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">Explore Collections</h3>
                            <p className="dark:text-jacarta-300">
                                Click Create and set up your collection. Add social links, a description, profile & banner images, and
                                set a secondary sales fee.
                            </p>
                        </Link>
                        <div
                            className="relative rounded-2.5xl border p-10 shadow-[0_5px_0_0_#ef4444] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(239,68,68,.3)] border-jacarta-700 bg-dark2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                className="absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600">
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path
                                    d="M10.9 2.1l9.899 1.415 1.414 9.9-9.192 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414L10.9 2.1zm2.828 8.486a2 2 0 1 0 2.828-2.829 2 2 0 0 0-2.828 2.829z" />
                            </svg>
                            <div className="mb-6 inline-flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                    className="h-12 w-12 fill-red">
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path
                                        d="M10.9 2.1l9.899 1.415 1.414 9.9-9.192 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414L10.9 2.1zm2.828 8.486a2 2 0 1 0 2.828-2.829 2 2 0 0 0-2.828 2.829z" />
                                </svg>
                            </div>
                            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">Start Selling & Growing</h3>
                            <p className="dark:text-jacarta-300">
                                Choose between auctions, fixed-price listings, and declining-price listings. You choose how you want to
                                sell your NFTs!
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-24 bg-dark">
                <div className="container">
                    <h2 className="mb-16 text-center font-display text-3xl text-jacarta-700 dark:text-white">
                        Create and sell your NFTs
                    </h2>
                    <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
                        <div className="text-center">
                            <div className="mb-6 inline-flex rounded-full bg-[#CDBCFF] p-3">
                                <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-accent">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        className="h-5 w-5 fill-white"
                                    >
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path
                                            d="M22 6h-7a6 6 0 1 0 0 12h7v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2zm-7 2h8v8h-8a4 4 0 1 1 0-8zm0 3v2h3v-2h-3z"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">1. Set up your wallet</h3>
                            <p className="dark:text-gray-400">
                                Once you've set up your wallet of choice, connect it to Terra Station clicking the NFT Marketplacein the top
                                right corner.
                            </p>
                        </div>
                        <div className="text-center">
                            <div className="mb-6 inline-flex rounded-full bg-[#C4F2E3] p-3">
                                <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-green">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        className="h-5 w-5 fill-white"
                                    >
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
                                    </svg>
                                </div>
                            </div>
                            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">2. Create Your Collection</h3>
                            <p className="dark:text-gray-400">
                                Click Create and set up your collection. Add social links, a description, profile & banner images, and
                                set a secondary sales fee.
                            </p>
                        </div>
                        <div className="text-center">
                            <div className="mb-6 inline-flex rounded-full bg-[#CDDFFB] p-3">
                                <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        className="h-5 w-5 fill-white"
                                    >
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path
                                            d="M17.409 19c-.776-2.399-2.277-3.885-4.266-5.602A10.954 10.954 0 0 1 20 11V3h1.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1h2v4H4v7c5.22 0 9.662 2.462 11.313 7h2.096zM18 1v4h-8V3h6V1h2zm-1.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">3. Add Your NFTs</h3>
                            <p className="dark:text-gray-400">
                                Upload your work, add a title and description, and customize your NFTs
                                with properties, stats.
                            </p>
                        </div>
                        <div className="text-center">
                            <div className="mb-6 inline-flex rounded-full bg-[#FFD0D0] p-3">
                                <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-red">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        className="h-5 w-5 fill-white">
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path
                                            d="M10.9 2.1l9.899 1.415 1.414 9.9-9.192 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414L10.9 2.1zm2.828 8.486a2 2 0 1 0 2.828-2.829 2 2 0 0 0-2.828 2.829z"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">4. List Them For Sale</h3>
                            <p className="dark:text-gray-400">
                                Choose between auctions, fixed-price listings, and declining-price listings. You choose how you want to
                                sell your NFTs!
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </>
}

export default HomePage;